import { api } from '../config/base-api';

export interface PatchCheckoutSessionBody {
  selectedPlan?: string;
  additionalData?: {
    dataForm?: Record<string, unknown>;
    dataLead?: Record<string, unknown>;
    pixV3PaymentData?: Record<string, unknown> | null;
  };
}

export async function patchCheckoutSession(
  cartId: string,
  body: PatchCheckoutSessionBody
): Promise<void> {
  await api.patch(`/api/v1/sessions/checkout/${cartId}`, body);
}
